<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	import IrrigationZonesSettings from 'src/components/XT1/Irrigation/IrrigationZonesSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<SidepanelContent>
	<IrrigationZonesSettings useV2 {device} />
</SidepanelContent>
